import React from "react";
import dynamic from "next/dynamic";
import {
  CellType,
  ComponentType,
  IListComponentModel,
  IMediaModel,
  Orientation,
} from "@nf/common";
const GridComponent = dynamic<any>(() =>
  import("../Configuration/ListComponent/components/GridComponent").then(
    (mod) => mod.GridComponent
  )
);
import styles from "./CollectionListDetails.module.scss";

export const CollectionListDetails = ({ media }: { media?: IMediaModel }) => {
  const collectionListModel: IListComponentModel = {
    CellType: CellType.AssetDetails,
    ComponentTypeCode: ComponentType.List,
    Orientation: Orientation.Vertical,
    MediaList: media?.Media,
    QueryParams: {
      collection: media?.Id,
    },
  };

  return media ? (
    <GridComponent
      className={styles.gridContentCollectionContainer}
      columns={1}
      rows={media.Media ? media.Media.length : 0}
      component={collectionListModel}
      noAutoColumns={true}
    />
  ) : null;
};
